'use strict';

module.exports = '3.24.5';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/src/version.js
// module id = 380
// module chunks = 0